import AVText from 'src/components/elements/AVText';
import React from 'react';
import Styles from '../../../Styles';
import {Dimensions, Image, StyleSheet, View} from 'react-native';
import Localized from 'src/constants/AppStrings';
import {
  AnnouncementStylesDescriptor,
  CampusLocationListStylesDescriptor,
  ReferralDescriberData,
  RewardskDescriberData,
  RewardsLegacykDescriberData,
  SendSnackDescriberData,
} from 'src/components/elements/home/descriptor/DescriptorType';
import PointsIndicator from 'src/components/elements/rewards/PointsIndicator';
import ChevronRight from 'src/components/img/svg/ChevronRight';
import {UserRewardsTierIcon} from 'src/components/img/svg/rewards';
import AVTouchableOpacity from 'src/components/elements/AVTouchableOpacity';
import CoffeeIcon from 'src/components/img/svg/coffee/coffeeIcon';
import RewardCanteenHome from 'src/components/img/svg/RewardCanteenHome';
import GrpReferralRedesign from 'src/components/img/svg/GrpReferralredesign';
import RoundedAppButton, {
  RoundedAppButtonType,
} from 'src/components/elements/RoundedAppButton';
import ShopIconNew from 'src/components/img/svg/ShopIconNew';
import NewLocationMarker from 'src/components/img/svg/NewLocationMarker';
import GlobeMarker from 'src/components/img/svg/GlobeMarker';

export function getCampusLocationStyles(): {
  [key: string]: {[key: string]: number | string};
} {
  const _width = Dimensions.get('window').width;
  return {
    recentLocationAddressText: {
      fontWeight: '400',
      color: Styles.lightGray,
      width: _width - Styles.Spacing.m5 - Styles.Spacing.m3,
      fontSize: Styles.Fonts.f8,
      fontFamily: Styles.FontFamily.robotoRegular,
      textAlignVertical: 'center',
    },
    recentLocationViewLocationNameText: {
      textAlignVertical: 'center',
      color: Styles.black,
      fontSize: Styles.Fonts.f1,
      width: _width - Styles.Spacing.m5 - Styles.Spacing.m3,
      fontWeight: '700',
      textTransform: 'capitalize',
    },
    separator: {
      height: 1,
      backgroundColor: Styles.borderColor,
    },
    locationListView: {
      margin: Styles.Spacing.m3,
    },
    locationDisplatText: {},
    locationDisplatSubText: {},
    recentListborder: {},
    descriptionText: {
      fontFamily: Styles.FontFamily.robotoRegular,
    },
    greetNameText: {},
  };
}

export function getTileButton(
  buttonText: string,
  handleClick: () => void,
  outline?: boolean,
  height?: number,
): JSX.Element {
  return (
    <View
      style={{
        flex: 1,
        justifyContent: 'center',
        paddingVertical: Styles.Spacing.m2,
      }}
    >
      <RoundedAppButton
        buttonViewStyle={{
          width: '100%',
          height: height ? height : Styles.Heights.touchTargetHeight1,
        }}
        buttonContainerStyle={{
          width: '100%',
        }}
        textStyle={[
          {
            fontSize: Styles.Fonts.f8,
            fontWeight: '700',
          },
        ]}
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
        buttonType={
          outline ? RoundedAppButtonType.Outline : RoundedAppButtonType.Solid
        }
        titleText={buttonText}
        accessibilityLabelValue={buttonText}
        aria-label={buttonText}
        onPress={handleClick}
        numberOfLines={2}
      />
    </View>
  );
}

export function rewardsLegacyViewDescriptor(
  props: RewardsLegacykDescriberData,
): JSX.Element {
  const {onRewardsClick, styles, stat, isOfferAvailable} = props;
  return (
    <React.Fragment>
      <AVTouchableOpacity
        aria-label={[Localized.Labels.rewards, stat].join('. ')}
        accessible={true}
        accessibilityLabel={[Localized.Labels.rewards, stat].join('. ')}
        accessibilityHint="Double tap to navigate to the rewards screen"
        accessibilityRole="button"
        role="button"
        onPress={onRewardsClick}
        style={{marginTop: Styles.Spacing.m3}}
      >
        <View style={styles.container}>
          <View style={styles.starIconView}>
            <View style={{}} accessibilityLabel={'RewardsIcon'}>
              <RewardCanteenHome />
            </View>
            <View
              style={{
                flex: 1,
                marginVertical: Styles.Spacing.m3,
                marginLeft: Styles.Spacing.m3,
              }}
            >
              <AVText
                accessibilityRole="text"
                style={{
                  color: Styles.black,
                  fontFamily: Styles.FontFamily.robotoRegular,
                  fontSize: 18,
                  fontWeight: '700',
                }}
                accessibilityLabel={Localized.Labels.rewards}
                aria-label={`${Localized.Labels.rewards}, text`}
                maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm4}
              >
                {Localized.Labels.rewards}
              </AVText>
              <AVText
                accessibilityRole="text"
                aria-label={`${stat}, text`}
                accessibilityLabel={`${stat}, text`}
                style={[
                  {
                    fontFamily: Styles.FontFamily.robotoRegular,
                    fontWeight: '700',
                    color: Styles.black,
                    fontSize: 18,
                  },
                  isOfferAvailable && {
                    paddingBottom: Styles.Spacing.m2,
                  },
                ]}
                maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm4}
              >
                {stat}
              </AVText>
              {isOfferAvailable && (
                <AVText
                  accessibilityRole="text"
                  aria-label={`${stat}, text`}
                  accessibilityLabel={`${stat}, text`}
                  style={{
                    fontFamily: Styles.FontFamily.robotoRegular,
                    fontWeight: '400',
                    color: Styles.black,
                    fontSize: 16,
                  }}
                  maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm4}
                >
                  {Localized.Labels.offerAvailable}
                </AVText>
              )}
            </View>
          </View>

          <View style={{justifyContent: 'center'}}>
            <ChevronRight />
          </View>
        </View>
      </AVTouchableOpacity>
    </React.Fragment>
  );
}
export function rewardsViewDescriptor(
  props: RewardskDescriberData,
): JSX.Element {
  const {
    onRewardsClick,
    styles,
    rewardTier,
    bgSize,
    tileHeight,
    productThresholds,
    maxPointValue,
    marketAccountPoints,
    maxPointsLabel,
  } = props;
  return (
    <React.Fragment>
      <AVTouchableOpacity
        activeOpacity={0.75}
        accessibilityLabel={Localized.Labels.pay_earn_enjoy}
        accessibilityHint="Press to navigate to rewards"
        style={{marginBottom: 20}}
        onPress={onRewardsClick}
        testID="qa_btn_RewardPoints"
      >
        <View
          style={[styles.container, {paddingHorizontal: Styles.Spacing.m3}]}
        >
          <View style={[styles.shadowWrapper]}>
            <UserRewardsTierIcon
              tierName={rewardTier?.tierName}
              size={bgSize}
              style={styles.tierIcon}
            />

            <PointsIndicator
              height={tileHeight - Styles.Spacing.m3 * 3}
              availablePoints={marketAccountPoints}
              thresholds={productThresholds}
              maxPointValue={maxPointValue}
              maxPointValueLabel={maxPointsLabel}
              rewardedColor={'#409F68'}
            />

            <View style={styles.content}>
              <AVText
                style={[
                  styles.payEarnEnjoy,
                  {fontFamily: Styles.FontFamily.robotoRegular},
                ]}
              >
                {Localized.Labels.pay_earn_enjoy}
              </AVText>

              <View style={styles.rewardStatus}>
                <AVText
                  style={[
                    styles.rewardStatustxt,
                    {fontFamily: Styles.FontFamily.robotoRegular},
                  ]}
                >
                  {Localized.Labels.rewards_status}
                </AVText>

                <AVText
                  style={[
                    styles.currentTierName,
                    {fontFamily: Styles.FontFamily.robotoRegular},
                  ]}
                >
                  {rewardTier?.tierName}
                </AVText>
              </View>
            </View>

            <ChevronRight
              color={Styles.Colors.PayNew.darkHuesBase04}
              style={styles.chevron}
            />
          </View>
        </View>
      </AVTouchableOpacity>
    </React.Fragment>
  );
}
export function snackViewDescriptor(
  props: SendSnackDescriberData,
): JSX.Element {
  const {onSendASnackClick, styles} = props;
  return (
    <React.Fragment>
      <View style={styles.headerView}>
        <AVText
          accessibilityRole="text"
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
          accessibilityLabel={Localized.Labels.gifting_title}
          style={{
            fontWeight: '700',
            paddingLeft: 16,
            fontSize: 24,
            fontFamily: Styles.FontFamily.aeonikRegular,
            color: Styles.black,
          }}
          accessible={true}
          aria-label={`${Localized.Labels.gifting_title}, text`}
        >
          {Localized.Labels.gifting_title}
        </AVText>
      </View>
      <AVTouchableOpacity
        aria-label="onSnackGiftClick"
        accessible={true}
        accessibilityLabel="onSnackGiftClick"
        accessibilityHint="Double tap to navigate to the send a snack screen"
        accessibilityRole="button"
        role="button"
        onPress={onSendASnackClick}
        testID="qa_btn_SnackGift"
      >
        <View style={styles.container}>
          <View
            aria-label={'SnackIcon'}
            role="img"
            accessibilityRole="image"
            accessibilityLabel={'SnackIcon'}
          >
            <Image
              accessibilityLabel="Snack gift"
              accessibilityRole="image"
              role="img"
              accessible={true}
              aria-label="Snack gift"
              style={{width: 63, height: 56}}
              resizeMode="contain"
              source={require('../../../img/canteenSnackGift.gif')}
            />
          </View>
          <View style={{flex: 1, margin: Styles.Spacing.m3}}>
            <AVText
              accessibilityRole="text"
              aria-label={`${Localized.Buttons.send_a_snack}, text`}
              style={{
                fontSize: 20,
                fontWeight: '700',
                color: Styles.black,
                fontFamily: Styles.FontFamily.aeonikRegular,
              }}
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm4}
              accessibilityLabel={Localized.Buttons.send_a_snack}
            >
              {Localized.Labels.send_a_snack_title}
            </AVText>

            <AVText
              accessibilityLabel={
                Localized.Labels
                  .send_your_colleagues_tasty_snacks_to_brighten_their_day
              }
              aria-label={
                Localized.Labels
                  .send_your_colleagues_tasty_snacks_to_brighten_their_day
              }
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
              style={{
                color: Styles.black,
                fontSize: 18,
                fontFamily: Styles.FontFamily.aeonikRegular,
                fontWeight: '400',
              }}
              accessibilityRole="text"
            >
              {
                Localized.Labels
                  .send_your_colleagues_tasty_snacks_to_brighten_their_day
              }
            </AVText>
          </View>

          <View>
            <ChevronRight />
          </View>
        </View>
      </AVTouchableOpacity>
    </React.Fragment>
  );
}
export function getScanAndPayTile(): {
  [key: string]: {[index: string]: number | string};
} {
  return {
    iconViewBackground: {
      backgroundColor:
        Styles.Colors.Canteen.darkGreen + Styles.Fonts.sectionHeader,
      margin: Styles.Spacing.m3,
      height: Styles.Heights.h5,
      width: Styles.Heights.h5,
    },
    rowSpace: {
      marginVertical: Styles.Spacing.m2,
    },
    titleText: {
      color: Styles.black,
      fontWeight: '700',
      fontSize: Styles.Fonts.f7,
      fontFamily: Styles.FontFamily.figtreeRegular,
      paddingBottom: Styles.Spacing.m2,
      marginRight: Styles.Spacing.m6 - Styles.Fonts.f1,
    },
    newTitleText: {
      width: '100%',
      color: Styles.darkColor,
      fontWeight: '700',
      fontSize: Styles.Fonts.f7,
      fontFamily: Styles.FontFamily.figtreeRegular,
      paddingBottom: Styles.Spacing.m2,
    },
    listContainer: {
      marginTop: Styles.Spacing.m3,
    },
    nameText: {
      marginRight: Styles.Spacing.m6 - Styles.Fonts.f1,
      color: Styles.black,
      fontWeight: '400',
      fontFamily: Styles.FontFamily.robotoRegular,
      fontSize: Styles.Fonts.f7,
    },
    coffeeMachineLabel: {
      color: Styles.Colors.CompanyKitchen.lightGray,
      fontWeight: '400',
      fontSize: Styles.Fonts.f0,
      fontFamily: Styles.FontFamily.figtreeRegular,
      paddingBottom: Styles.Spacing.m2,
      width: '100%',
    },
    textView: {
      marginVertical: Styles.Spacing.m3,
    },
  };
}
export function infoIconPrimaryColor() {
  return '#003349';
}
export function infoIconInnerColor() {
  return '#A5CF4F';
}
export function announcemnentButtonColor() {
  return Styles.primaryColor;
}
export function announcementBtnFont(): string {
  return Styles.FontFamily.robotoRegular;
}

export function getAnnouncementStyles(): AnnouncementStylesDescriptor {
  return StyleSheet.create({
    container: {
      backgroundColor: '#fff',
      marginTop: Styles.Spacing.m3 - 4,
      marginHorizontal: Styles.Spacing.m3,
      marginBottom: Styles.Spacing.m2 + 4,
      borderRadius: Styles.Spacing.m2,
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      ...Styles.Style.shadow,
    },
    titleText: {
      fontSize: Styles.Fonts.headerFont,
      width: '80%',
      fontWeight: '700',
      color: Styles.black,
      marginRight: Styles.Spacing.m3,
      marginLeft: Styles.Spacing.m3,
      textAlign: 'left',
      fontFamily: Styles.FontFamily.aeonikRegular,
    },
    descriptionText: {
      fontSize: Styles.Fonts.sectionHeader,
      color: Styles.darkColor,
      fontWeight: '400',
      fontFamily: Styles.FontFamily.latoRegular,
    },
  });
}

export function getWidthImageAvailable() {
  return '70%';
}

export function getCampusLocationListStyles(): CampusLocationListStylesDescriptor {
  return StyleSheet.create({
    container: {
      marginTop: Styles.Spacing.m3,
      flex: 1,
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      marginBottom: Styles.Spacing.m3,
    },
    campusLocationListView: {
      width: '100%',
    },
    headerMargin: {
      marginLeft: Styles.Spacing.m3,
      marginTop: -(Styles.Spacing.m3 + Styles.Spacing.m2),
    },
    diningLocationLabel: {
      color: Styles.Colors.PayNew.black01,
      fontFamily: Styles.FontFamily.aeonikRegular,
    },
  });
}
export function referralViewDescriptor(
  props: ReferralDescriberData,
  amtLocalised?: string,
): JSX.Element {
  const {onInviteClick, styles, stat, isSnackEnabled} = props;
  const desc = Localized.Labels.formatString(
    Localized.Labels.receive_redesign_cash_to_spend,
    amtLocalised,
  );
  const title = Localized.Labels.formatString(
    Localized.Labels.give_get_redesign,
    amtLocalised,
    amtLocalised,
  );
  return (
    <React.Fragment>
      {!isSnackEnabled && (
        <View style={styles.headerView}>
          <AVText
            accessibilityRole="text"
            style={{
              fontWeight: '700',
              fontSize: Styles.Fonts.f9,
              fontFamily: Styles.FontFamily.aeonikRegular,
              color: Styles.black,
            }}
            maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
            accessible={true}
            aria-label={`${Localized.Labels.recents}, text`}
            accessibilityLabel={Localized.Labels.recents}
          >
            {Localized.Labels.gifting_title}
          </AVText>
        </View>
      )}
      <AVTouchableOpacity
        accessible={true}
        onPress={onInviteClick}
        accessibilityLabel={[title, desc, stat].join('. ')}
        accessibilityHint="Double tap to navigate to the Refferals screen"
        role="button"
        aria-label={[title, desc, stat].join('. ')}
        accessibilityRole="button"
        testID="qa_btn_Refferals"
      >
        <View style={styles.container} nativeID="qa_btn_Refferals">
          <View
            role="img"
            accessibilityLabel={'grpreferralIcon'}
            accessibilityRole="image"
            aria-label={'grpreferralIcon'}
          >
            <GrpReferralRedesign
              width={63}
              height={56}
              gradColor1={Styles.Colors.Canteen.darkGreen}
              gradColor2={Styles.Colors.Canteen.lightGreen}
            />
          </View>
          <View style={{flex: 1, margin: Styles.Spacing.m3}}>
            <AVText
              aria-label={`${title}, text`}
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm4}
              accessibilityRole="text"
              style={{
                fontWeight: '700',
                paddingVertical: Styles.Spacing.m2,
                fontSize: Styles.Fonts.sectionHeader,
                fontFamily: Styles.FontFamily.aeonikRegular,
                color: Styles.black,
              }}
              accessibilityLabel={title as string}
            >
              {title}
            </AVText>

            <AVText
              accessibilityLabel={desc as string}
              aria-label={desc as string}
              accessibilityRole="text"
              style={{
                fontWeight: '400',
                fontSize: Styles.Fonts.f7,
                color: Styles.black,
                fontFamily: Styles.FontFamily.aeonikRegular,
              }}
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
            >
              {desc}
            </AVText>
            <AVText
              accessibilityRole="text"
              accessibilityLabel={Localized.Labels.receive_cash_to_spend}
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
              aria-label={Localized.Labels.receive_cash_to_spend}
              style={{
                fontFamily: Styles.FontFamily.latoRegular,
                fontSize: Styles.Fonts.f7,
                fontWeight: '400',
                color: '#727179',
              }}
            >
              {stat}
            </AVText>
          </View>

          <View>
            <ChevronRight />
          </View>
        </View>
      </AVTouchableOpacity>
    </React.Fragment>
  );
}
export function getEngagementCarouselPaginationActiveDotColor(): string {
  return '#003349';
}

export function locationListIcon(): JSX.Element {
  return <ShopIconNew size={Styles.Spacing.m4} />;
}
export function RecentlocationListIcon(): JSX.Element {
  return <ShopIconNew size={24} />;
}
export function getScanAndPayTileIcon(coffeMachineType: boolean): JSX.Element {
  if (coffeMachineType) {
    return <CoffeeIcon width={26} height={26} color={Styles.primaryColor} />;
  } else {
    return (
      <Image
        source={require('src/components/img/scanIconCanteen.png')}
        style={{
          width: Styles.Heights.h5 / 2,
          height: Styles.Heights.h5 / 2,
        }}
      />
    );
  }
}

export function getVendingTile(): {
  [key: string]: {[index: string]: number | string};
} {
  return {
    headerText: {
      color: Styles.black,
      fontSize: Styles.Fonts.headerFont,
      fontWeight: '700',
      fontFamily: Styles.FontFamily.robotoRegular,
      marginTop: 16,
      marginLeft: Styles.Spacing.m2,
    },
    nameText: {
      width: '100%',
      color: Styles.darkColor,
      fontWeight: '700',
      fontSize: Styles.Fonts.f1,
      fontFamily: Styles.FontFamily.figtreeRegular,
    },
    vendingSmatxt: {
      color: Styles.black,
      fontSize: Styles.Fonts.f9 - 6,
      fontWeight: '400',
      fontFamily: Styles.FontFamily.robotoRegular,
      fontStyle: 'italic',
      marginTop: 16,
      paddingHorizontal: 24,
    },
    buttonText: {
      color: Styles.primaryColor,
      backgroundColor: 'transparent',
      fontSize: Styles.Fonts.f1,
      fontWeight: '600',
      fontStyle: 'normal',
    },
  };
}

export function getDiningTile(): {
  [key: string]: {[index: string]: number | string};
} {
  const windowWidth = Dimensions.get('window').width;
  return {
    nameText: {
      color: Styles.darkColor,
      fontWeight: '700',
      fontSize: Styles.Fonts.sectionHeader,
      marginTop: Styles.Spacing.m2,
      paddingLeft: Styles.Spacing.m1,
      fontFamily: Styles.FontFamily.robotoRegular,
      width: windowWidth - Styles.Spacing.m4 - Styles.Spacing.m3,
    },
  };
}

export function getQRCodeTile(): {
  [key: string]: {[index: string]: number | string};
} {
  return {
    quickFundText: {
      fontFamily: Styles.FontFamily.robotoRegular,
      fontWeight: '700',
      fontSize: Styles.Fonts.f1,
    },
    balanceText: {
      color: Styles.darkColor,
      fontWeight: '400',
      fontSize: Styles.Fonts.f7,
      fontFamily: Styles.FontFamily.robotoRegular,
    },
    balanceValue: {
      fontSize: Styles.Fonts.f2,
      fontWeight: '700',
      fontFamily: Styles.FontFamily.robotoRegular,
    },
  };
}

export function getScanAndPayMismatchLocationError(): JSX.Element {
  return (
    <View style={styles.locationErrorContainer}>
      <AVText
        accessibilityElementsHidden={true}
        style={styles.locationDescription}
        accessibilityLabel={
          Localized.Labels.your_account_balance_is_not_valid_at_some_locations
        }
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
        aria-label={`${Localized.Labels.your_account_balance_is_not_valid_at_some_locations}, text`}
        accessibilityRole="text"
      >
        {'*' +
          Localized.Labels.your_account_balance_is_not_valid_at_some_locations}
      </AVText>
    </View>
  );
}

function getLocationMarkerErrorIcon(locationEnabled: boolean) {
  return locationEnabled ? (
    <NewLocationMarker
      primaryFill={Styles.Colors.Canteen.darkGreen}
      secondaryFill={Styles.Colors.Canteen.lightGray}
    />
  ) : (
    <GlobeMarker primaryFill={Styles.Colors.Canteen.darkGreen} />
  );
}

export function getNoNearbyLocationsComponent(
  locationEnabled: boolean,
): JSX.Element {
  return (
    <View
      style={{
        marginTop: Styles.Spacing.m3 + Styles.Spacing.m1,
        marginBottom: Styles.Spacing.m3 + Styles.Spacing.m1,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <View
        style={{
          justifyContent: 'center',
          alignItems: 'center',
          width: Styles.Heights.h5,
          height: Styles.Heights.h5,
          marginBottom: Styles.Spacing.m2,
          marginTop: Styles.Spacing.m4,
        }}
      >
        {getLocationMarkerErrorIcon(locationEnabled)}
      </View>
      <AVText
        style={{
          fontSize: Styles.Fonts.sectionHeader,
          fontWeight: '700',
          fontFamily: Styles.FontFamily.aeonikRegular,
          color: Styles.Colors.PayNew.black01,
          marginTop: Styles.Spacing.m4 + Styles.Spacing.m2,
          marginBottom: Styles.Spacing.m3,
          textAlign: 'center',
        }}
      >
        {locationEnabled
          ? Localized.Labels.there_are_no_locations_near_you
          : Localized.Labels
              .turn_location_services_on_to_access_nearby_locations}
      </AVText>
    </View>
  );
}

const styles = StyleSheet.create({
  locationErrorContainer: {
    marginHorizontal: Styles.Spacing.m0,
    marginVertical: Styles.Spacing.m1,
  },
  locationHeader: {
    color: Styles.black,
    fontSize: Styles.Fonts.headerFont,
    fontWeight: '700',
    fontFamily: Styles.FontFamily.robotoRegular,
    textTransform: 'capitalize',
  },
  locationDescription: {
    fontFamily: Styles.FontFamily.robotoRegular,
    color: Styles.black,
    fontSize: Styles.Fonts.f1,
    fontWeight: '400',
    textAlign: 'left',
    marginTop: Styles.Spacing.m2,
    marginLeft: -Styles.Spacing.m1,
    fontStyle: 'italic',
  },
});

export default {
  getAnnouncementStyles,
  getCampusLocationStyles,
  getScanAndPayTile,
  referralViewDescriptor,
  getWidthImageAvailable,
  announcemnentButtonColor,
  snackViewDescriptor,
  infoIconPrimaryColor,
  infoIconInnerColor,
  getCampusLocationListStyles,
  rewardsViewDescriptor,
  announcementBtnFont,
  RecentlocationListIcon,
  getEngagementCarouselPaginationActiveDotColor,
  locationListIcon,
  rewardsLegacyViewDescriptor,
  getScanAndPayTileIcon,
  getVendingTile,
  getDiningTile,
  getQRCodeTile,
  getScanAndPayMismatchLocationError,
  getTileButton,
  getNoNearbyLocationsComponent,
};
